export default "__VITE_ASSET__BTdeMWZ8__"